module.exports = __webpack_public_path__ + "static/media/codexHeader.9f7bb148.png";